import { response } from "express";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { lastValueFrom, takeUntil, Subject } from "rxjs";
import Swal, { SweetAlertIcon } from "sweetalert2";

/*********************SERVICES*********************/
import { IntegracionServices } from "src/app/core/services/integraciones.service";
/*********************MODEL*********************/
import { LoteDetalleUrl } from "src/app/models/LoteDetalleUrl.model";
import { LoteDetalleUrlCoordenada } from "src/app/models/LoteDetalleUrlCoordenada.model";
@Component({
  selector: "app-visor-wrapper",
  templateUrl: "./visor-wrapper.component.html",
  styleUrls: ['./visor-wrapper.component.scss']
})
export class VisorWrapperComponent implements OnInit {
  documentPdfUrl: any;
  certificado: any;
  public listCertificados: any;
  public loteDetalleUrls: LoteDetalleUrl[] = [];
  idPrecargar: string = "";
  idUrl: string = "";
  es_grupo = false;
  readonly = false;
  usa_plantilla = false;
  validate = false;
  modulo = "simple";
  public hora = '';
  public minutos = '';
  public segundos = '';

  public countSig = 0;
  public findAllCount = 0;
  private destroy$ = new Subject<void>();
  toast = Swal;
  public urlCoordenada: any;
  urlJosite: string = '';
  nombreCorto: string = '';
  almacenarPlantillaFirma:boolean = false;

  constructor(
    private integracionServices: IntegracionServices,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.toastAlert();
    this.actualizarHora();
    this.listCertificados = [];
    this.route.paramMap
      .pipe(takeUntil(this.destroy$)) // Desuscribe automáticamente al destruir el componente
      .subscribe(async (params) => {
        // 'id' es el nombre del parámetro definido en tu configuración de rutas
        // Por ejemplo: path: 'firmas/firma/:id'
        const id = params.get("id");
        if (id) {
          this.idPrecargar = String(id);
          this.getintegracionUrls(this.idPrecargar);
        }
      });
  }

  async getintegracionUrls(id: string) {
    const response = await lastValueFrom(
      this.integracionServices.getPrecargarCalibraciones(id),
    );
    
    this.urlCoordenada = response.body;
    this.loteDetalleUrls = response.body.urls as LoteDetalleUrl[];
    this.certificado = this.certificados(response.body.firmantes);
    this.urlJosite = response.body.urlout;
    this.nombreCorto = response.body.nombre_corto_sistema;
    this.almacenarPlantillaFirma = response.body.almacenar_plantilla_firma;     
    await this.countSignature();
  }

   async saveAreas() {
    await this.getintegracionUrls(this.idPrecargar);

    //if(this.almacenarPlantillaFirma){}


    this.validate = await this.validCoordenadas();

    if (this.validate) {
      const createPlantillaExterna = await this.createPlatillaExterna() as any[];
    
      if (createPlantillaExterna) {

        if(this.almacenarPlantillaFirma){
            const resultado = createPlantillaExterna.map((x: any) => ({
              id: x.id,
              id_plantilla_fe: x.id_plantilla_fe
            }));

            //endpoint, datos
            let payload = {
              endpoint: `contract/templates/fe/asociar`,
              datos: {
                plantillas:resultado
              }          
            }
            let responseJobsite  = lastValueFrom(await this.integracionServices.saveSistemaExterno(payload,  'JOBSITE' , true));        
        }
        
        window.location.href = this.urlJosite;
      }
    }

  }

  obtenerIds() {
    const ids = this.loteDetalleUrls.map(x => x.id).join(',');
    return ids
  }

  async getCoordenada() {
    const response = await lastValueFrom(
      this.integracionServices.getObtenerCoordenada(
        this.idPrecargar,
        this.idUrl,
      ),
    );
    if (response) {
      this.listCertificados = response.body.map((x: any) => {
        return {
          id: x.id,
          pagina: x.npagina,
          // nombre_grupo: x.nombre_firmante,
          coordenada_frontend: x.coordenada_frontend,
          certificado: {
            id: x.nombre_corto_firmante,
            usuario: {
              firstName: x.nombre_firmante,
              lastName: ''
            }
          }
        };
      });


    } else {
      this.listCertificados = [];
    }

    this.findAllCount = this.listCertificados.length;
  }

  certificados(array: any[] = []) {
    return array.map((x: any) => {
      return {
        id_certificado: x.nombre_corto,
        name: x.nombre,
      };
    });
  }

  async onAddCertificado(data: any) {
    let body = {
      nombre_firmante: this.obtenerFirmarte(data.id_certificado),
      coordenada: data.coordenada,
      coordenada_frontend: data.coordenada_frontend,
      nombre_corto_firmante: data.id_certificado,
      npagina: data.pagina,
    };

    const response = await lastValueFrom(
      this.integracionServices.createCoordenadas(
        this.idPrecargar,
        this.idUrl,
        body,
      ),
    );

    let save = await this.saveJobsite(body);

    if (save) {
      this.actualizarHora();
      this.alert('success', 'Éxito!', 'Coordenada registrada con éxito.');
    }

    this.getCoordenada();
  }

  async saveJobsite(body: any) {
    const datos = {
      "endpoint": `contract/template/${this.idUrl}/calibration`,
      "datos": body
    }
    const response = await lastValueFrom(this.integracionServices.saveSistemaExterno(datos, this.nombreCorto));

    return response;
  }

  async onDeleteCertificado(data: any) {

    const response = await lastValueFrom(
      this.integracionServices.deleteCoordenada(
        this.idPrecargar,
        this.idUrl,
        data.idLoteDetalleCoordenada,
      ),
    );

    let body = {
      nombre_firmante: "",
      coordenada: "",
      coordenada_frontend: "",
      nombre_corto_firmante: data.id, /* aqui viene el nombre corte, viene en un id porque se toma el nombre corto como id de la coordenada */
      npagina: "",
    };

    let delet = await this.saveJobsite(body);

    if (delet) {
      this.actualizarHora();
      this.alert('success', 'Éxito!', 'Coordenada eliminada con éxito.');
    }

    this.getCoordenada();
  }

  async selectDocument(id_document: number) {
    const item = this.loteDetalleUrls.find((x) => x.id === id_document);
    this.idUrl = String(item?.id);
    this.documentPdfUrl = item?.url;
    this.getCoordenada();
  }

  obtenerFirmarte(id_firmante: string) {
    const certificado = this.certificado.find(
      (x: any) => x.id_certificado === id_firmante,
    );
    return certificado.name;
  }

  async validCoordenadas() {
    await this.findAllCoordenada();
    if (this.countSig != this.findAllCount) {
      this.alert(
        'warning',
        'Faltan coordenadas',
        'Debe asignar todas las coordenadas antes de finalizar.'
      );
      return false;
    }

    return true;
  }


  async countSignature() {
    let countCert = this.certificado.length;
    let countDoc = this.loteDetalleUrls.length;
    this.countSig = (countCert * countDoc);
  }

  async findAllCoordenada() {
    this.findAllCount = this.urlCoordenada.urls.reduce(
      (total: number, url: any) => total + (url.coordenadas?.length || 0),
      0
    );
  }

  async createPlatillaExterna() {
    const response = await lastValueFrom(this.integracionServices.createPlatillaExterna(this.idPrecargar));

    return response;
  }

  toastAlert() {
    this.toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  }

  alert(icontext: SweetAlertIcon, title: string, text: string = "") {
    this.toast.fire({
      icon: icontext,
      title: title,
      text: text,
    });
  }

  actualizarHora(): void {
    const ahora = new Date();

    this.hora = String(ahora.getHours()).padStart(2, '0');
    this.minutos = String(ahora.getMinutes()).padStart(2, '0');
    this.segundos = String(ahora.getSeconds()).padStart(2, '0');
  }
}
